<template>
  <div class="layout_ policy_layout_">
    <navbar />
    <div class="content_ w1000_ w1200_">
      <div class="breadcrum_">首页 > 保单管理</div>
      <div class="tabs_ bold_">
        <div :class="[act_ == 'user' ? 'active_' : '']" @click="goUserInfo">
          账号管理
        </div>
        <!-- <div>发票管理</div> -->

        <div
          v-if="type == 1"
          :class="[act_ == 'order' ? 'active_' : '']"
          @click="goOrdered"
        >
          保单管理
        </div>
        <div
          v-else
          :class="[act_ == 'florder' ? 'active_' : '']"
          @click="flOrdered"
        >
          妇联保单管理
        </div>
        <!-- <div>理赔管理</div> -->
      </div>
      <div class="labels_wrap_" v-if="act_ == 'order'">
        <router-link
          exact-active-class="active_"
          class="label_"
          :to="{ name: 'gdordered' }"
          >已出单保单</router-link
        >
        <!-- <router-link exact-active-class="active_" class="label_" :to="{name: 'surrender'}" v-if="myArray.indexOf(3)>-1">退保保单</router-link>-->
        <router-link
          exact-active-class="active_"
          class="label_"
          :to="{ name: 'gdmanage' }"
          >保单批改</router-link
        >
        <!-- <router-link exact-active-class="active_" class="label_" :to="{name: 'query'}" v-if="myArray.indexOf(7)>-1">批改查询</router-link> -->
      </div>
      <div class="labels_wrap_" v-if="act_ == 'florder'">
        <router-link
          exact-active-class="active_"
          class="label_"
          :to="{ name: 'flordered' }"
          >妇联已出单保单</router-link
        >
      </div>
      <router-view></router-view>
    </div>
    <footbar></footbar>
  </div>
</template>
<style lang="scss" scoped>
.layout_ {
  .labels_wrap_ {
    font-size: 13px;
    white-space: nowrap;
    margin: 26px 0 30px;
    .label_ {
      display: inline-block;
      margin-right: 33px;
      color: #666666;
      text-decoration: none;
      &.router-link-exact-active {
      }

      &.active_ {
        color: #333;
        &::after {
          display: block;
          content: "";
          width: 25px;
          height: 2px;
          margin: 0 auto;
          background: #ff4c1c;
          margin-top: 8px;
        }
      }
    }
  }
  .breadcrum_ {
    font-size: 12px;
    color: #666666;
    margin: 34px 0 24px;
  }
  .tabs_ {
    line-height: 49px;
    border-bottom: 3px solid #ff4c1c;

    & > div {
      display: inline-block;
      width: 215px;
      height: 50px;
      text-align: center;
      border-radius: 3px 3px 0px 0px;
      font-size: 17px;
      margin-bottom: -1px;
      cursor: pointer;
      &.active_ {
        color: #fff;
        background: rgba(255, 76, 28, 1);
      }
    }
  }
}
</style>
<script>
import navbar from "../components/navbar";
import footbar from "../components/footbar";
import { getLogined, getToken, getUserInfo } from "@/utils/authorized";
import moment from "moment";
import api from "@/utils/api";
export default {
  data() {
    return {
      act_: "order",
      myArray: [],
      type: 1, //type==1为光大的账号，2为妇联
    };
  },
  components: {
    navbar,
    footbar,
  },
  mounted() {
    let user = getUserInfo();
    if (user && user.userName) {
      if (user.userName == "8631000038") {
        //光大商城测试账号、TODO:上生产时需要加个生产的账号
        this.type = 2;
        this.act_ = "florder";
      } else {
        this.type = 1;
        this.act_ = "order";
      }
    }
  },
  methods: {
    goUserInfo() {
      this.act_ = "user";
      this.$router.push({
        name: "changegdPwd",
      });
    },
    goOrdered() {
      this.act_ = "order";
      this.$router.push({
        name: "gdordered",
      });
    },
    flOrdered() {
      this.act_ = "florder";
      this.$router.push({
        name: "flordered",
      });
    },
  },
};
</script>
